import React from 'react';
import { IBreakConfig } from '../interfaces/schedule-period.interface';
import { TimeRangePicker, MiniInput, DefaultButton } from 'shared/ui';
import styles from './settings.module.scss';

interface IBreakInputProps {
  value: IBreakConfig;
  onChange: (value: IBreakConfig) => void;
  onDelete: () => void;
}

export const BreakInput: React.FC<IBreakInputProps> = ({
  value,
  onChange,
  onDelete,
}) => {
  return (
    <div className={styles.break_input}>
      <MiniInput
        inputValue={value.title}
        onChange={(v) => onChange({ ...value, title: v })}
        inputPlaceholder="Название"
        inputType="text"
        className={styles.break_input__title}
      />
      <TimeRangePicker
        timeRange={{ start: value.start, end: value.end }}
        onChange={(data) =>
          onChange({
            ...value,
            start: data.timeRange.start || value.start,
            end: data.timeRange.end || value.end,
          })
        }
        index={0}
      />
      <DefaultButton
        buttonText="×"
        color="red"
        className={styles.break_input__delete}
        onClick={onDelete}
      />
    </div>
  );
};
